import { render } from "./Analysis.vue?vue&type=template&id=2270436b&scoped=true"
import script from "./Analysis.vue?vue&type=script&lang=ts"
export * from "./Analysis.vue?vue&type=script&lang=ts"

import "./Analysis.vue?vue&type=style&index=0&id=2270436b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2270436b"

export default script